import { useCallback, useEffect, useState } from "react";
import { toast } from "react-hot-toast";

import { apiMain } from "services";

export const useFollowing = () => {
  const [following, setFollowing] = useState<string[]>([]);

  const sendFollow = (id: string) => {
    toast.success(`Started following ${id}`);

    apiMain.followUser(id).then(() => {
      console.debug(`Successfully subscribed to ${id}.`);
    }).catch((e: any) => {
      toast.error(`Error subscribing to ${id}: ${e.message}.`);
      console.error(`Error subscribing to ${id}: ${e.message}.`);
    });
  };

  const sendUnfollow = (id: string) => {
    toast.success(`Stopped following ${id}`);

    apiMain.unfollowUser(id).then(() => {
      console.debug(`Successfully unsubscribed from ${id}.`);
    }).catch((e: any) => {
      toast.error(`Error unsubscribing from ${id}: ${e.message}.`);
      console.error(`Error unsubscribing from ${id}: ${e.message}.`);
    });
  };

  const follow = useCallback((followId: string) => {
    setFollowing(prev => {
      sendFollow(followId);
      const without = prev.filter((userName: string): boolean => userName !== followId);
      return [...without, followId];
    });
  }, []);

  const unfollow = useCallback((unfollowId: string) => {
    sendUnfollow(unfollowId);
    setFollowing(prev => prev.filter((userName: string): boolean => userName !== unfollowId));
  }, []);

  const toggleSubscription = useCallback((userName: string) => {
    const isFollowing = following.indexOf(userName) >= 0;

    setFollowing((prev: string[]) => {
      if (isFollowing) {
        return prev.filter((id: string) => id !== userName);
      } else {
        return [...prev, userName];
      }
    });

    if (isFollowing) {
      sendUnfollow(userName);
    } else {
      sendFollow(userName);
    }
  }, [following]);

  useEffect(() => {
    apiMain.getFollowingIds().then((ids: string[]) => {
      setFollowing(ids);
      console.debug(`Subscription list read, ${ids.length} items.`);
    }).catch((e: any) => {
      console.error(`ERROR reading subscription list: ${e.message}.`);
    });
  }, []);

  return {
    following,
    follow,
    unfollow,
    toggleSubscription,
  };
};
